import { useState } from "react";
import { Column } from "../../../../core/components/Column";
import SettingComponent from "../components/SettingComponent";
import { Friends } from "../../../../core/icons/Friends";
import { Garbage } from "../../../../core/icons/Garbage";
import { ModalSimple } from "../../../../core/components/Modal";
import { IconDeleteAccount } from "../../../../core/icons/DeleteAccount";
import { IconLogoutAccount } from "../../../../core/icons/LogoutAccount";
import { Logout } from "../../../../core/icons/Logout";
import { Video } from "../../../../core/icons/Video";
import { Exclamation } from "../../../../core/icons/Exclamation";
import { SettingsNotification } from "../components/SettingsNotification";
import { InviteYourFriends } from "../components/InviteYourFriendsSettings";
import { AgeRangeSettings } from "../components/AgeRangeSettings";
import { MaximumDistance } from "../components/MaximumDistanceSettings";
import { DiscoverySettings } from "../components/DiscoverySettings";
import { SearchSettings } from "../components/SearchSettings";
import { AccountSettings } from "../components/AccountSettings";
import { PartnerSettings } from "../components/PartnerSettings";
import useLogout from "../../../../core/hooks/useLogout";
import { EmailGray } from "../../../../core/icons/Email";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ChangePasswordScreen } from "./ChangePasswordScreen";
import { useSelector } from "react-redux";
import { RootState } from "../../../../core/store/store";
import { isAffiliateCountryAllowed } from "../utils/affiliateCountries";

export const SettingsScreen: React.FC = () => {
	const navigate = useNavigate();
	const [searchParams, setSearchParams] = useSearchParams();
	const [isOpenWarning, setIsOpenWarning] = useState<boolean>(false);
	const [isOpenInvite, setIsOpenInvite] = useState<boolean>(false);
	const [isOpenWarningLogout, setIsOpenWarningLogout] = useState<boolean>(false);
	const { user, getProfileConfig } = useSelector((state: RootState) => state.onboarding);
	const logout = useLogout();
  const activeSection = searchParams.get("section");
	const showAffiliateProgram = isAffiliateCountryAllowed(user?.country);

	const settingsItems = [
		{ icon: <Exclamation />, title: "Report an Issue", path: "/settings/report-issue", showArrow: true },
		{ icon: <Friends />, title: "Community", path: "/community", showArrow: true },
		...(showAffiliateProgram
			? [{ icon: <Friends />, title: "Affiliate program", path: "/settings/affiliate", showArrow: true }]
			: []),
		{ icon: <Friends />, title: "Invite your friends", path: "/invite-friends", showArrow: false, onClick: () => setIsOpenInvite(true) },
		{ icon: <Logout />, title: "Logout", path: "/logout", showArrow: false, onClick: () => setIsOpenWarningLogout(true) },
		{
			icon: <Garbage />,
			title: "Delete Account",
			path: "/settings/delete-account",
			showArrow: false,
			onClick: () => setIsOpenWarning(true),
		},
		{
			icon: <EmailGray />,
			title: "Contact",
			path: "/settings/report-issue",
			showArrow: true,
		},
		{ icon: <Video />, title: "Tutorials", path: "/settings/tutorial", showArrow: true },
	];

	const logoutSession = () => {
		logout();
	};

  if (activeSection === "change-password") {
    return (
      <ChangePasswordScreen
        onBack={() => {
          setSearchParams({});
        }}
      />
    );
  }

	return (
		<>
			<div className="bg-white max-md:overflow-y-auto">
				<Column className="p-4 sm:w-full lg:w-3/4 xl:w-2/4">
					<AccountSettings />
					<DiscoverySettings />
					<PartnerSettings />
					{getProfileConfig ? (
						<>
							<MaximumDistance />
							<SettingsNotification />
							<SearchSettings />
							<AgeRangeSettings />
						</>
					) : <p role="status">Loading your preferences…</p>}

					{settingsItems.map((item) => (
						<div
							className="mb-3"
							key={item.path}
						>
							<SettingComponent
								icon={item.icon}
								title={item.title}
								path={item.path}
								className="bg-socondary select-none hover:bg-pink/40 transition-colors duration-300 ease-in-out"
								showArrow={item.showArrow}
								onClick={item.onClick}
							/>
						</div>
					))}
				</Column>
			</div>
			<ModalSimple
				title="Delete Account"
				variant="secondary"
				actionExecuted={isOpenWarning}
				onClose={() => {
					setIsOpenWarning(false);
				}}
				onAction={() => {
					setIsOpenWarning(false);
					navigate("/settings/delete-account");
				}}
				icon={<IconDeleteAccount />}
			>
				You are about to permanently delete your account. Are you sure you want to do this?
			</ModalSimple>

			<InviteYourFriends
				isOpenInvite={isOpenInvite}
				setIsOpenInvite={setIsOpenInvite}
			/>

			<ModalSimple
				title="Logout"
				variant="secondary"
				actionExecuted={isOpenWarningLogout}
				onClose={() => {
					setIsOpenWarningLogout(false);
				}}
				onAction={logoutSession}
				icon={<IconLogoutAccount />}
			>
				Would you like to logout of your account?
			</ModalSimple>
		</>
	);
};
